export const getURIParam = param => {
  const { search } = window.location;
  if (search) {
    const params = new URLSearchParams(search);
    return decodeURIComponent(params.get(param));
  }
  return null;
};
